export default [
  "#FF0079", // red
  "#4E5FF1", // cyan
  "#49DD9F", // green
  "#832FED", // purple
  "#3F51B5", // dark blue
  "#F9C80E", // yellow
  "#F86624", // orange
  "#F9A3A4", // pink
  "#8D5B4C", // brown
  "#A5978B", // gray
];
